import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import { initStoreServices, initCloudServices, getLatestTopProducts, getFirstImageFromCloudinary } from "../../services/productsService";
import "./Home.css";

/* ─── Banners del carrusel ───────────────────────────────────── */
const MOBILEBANNERS = [
  {
    id: 1,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454752/mobile-sales_do7rby.png",
    alt: "OFERTAS",
    label: "OFERTAS",
    title: "OFERTAS!",
    sub: "Aprovecha nuestras ofertas en articulos seleccionados!",
    cta: "Ver ofertas",
    ctaPath: "/shop?sales=true",
    dark: false,
  },
  {
    id:2,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454229/mobile-novedades_pfwb7a.jpg",
    alt: "Novedades",
    label: "NOVEDADES",
    title: "Las ultimas novedades",
    sub: "Checa nuestras ultimas novedades y recien llegados!",
    cta: "Ver novedades",
    ctaPath: "/shop?novelty=true",
    dark: false,
  },
  {
    id:3,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454229/mobile-preventas_nlg46n.jpg",
    alt: "Preventas",
    label: "Lo que esta por llegar",
    title: "PREVENTAS",
    sub: "Proximas preventas",
    cta: "Ver preventas",
    ctaPath: "/shop?preorder=preorder",
    dark: false,
  },
  {
    id:4,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454215/mobile-prox-ml_lwwlub.png",
    alt: "PAGOS",
    label: "PAGOS",
    title: "MAS METODOS DE COMPRA",
    sub: "Proximamente mas formas de comprar!",
    cta: "ML",
    dark: false,
  }
];

const WEBBANNERS = [
  {
    id: 1,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454750/web-sales_msavwp.png",
    alt: "OFERTAS",
    label: "OFERTAS",
    title: "OFERTAS!",
    sub: "Aprovecha nuestras ofertas en articulos seleccionados!",
    cta: "Ver ofertas",
    ctaPath: "/shop?sales=true",
    dark: false,
  },
  {
    id:2,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454215/web-novedades_lcftdc.png",
    alt: "Novedades",
    label: "NOVEDADES",
    title: "Las ultimas novedades",
    sub: "Checa nuestras ultimas novedades y recien llegados!",
    cta: "Ver novedades",
    ctaPath: "/shop?novelty=true",
    dark: false,
  },
  {
    id:3,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454216/web-preventas_jmapcj.png",
    alt: "Preventas",
    label: "Lo que esta por llegar",
    title: "PREVENTAS",
    sub: "Proximas preventas",
    cta: "Ver preventas",
    ctaPath: "/shop?preorder=preorder",
    dark: false,
  },
  {
    id:4,
    src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1780454215/web-prox-ml_onf9e7.png",
    alt: "PAGOS",
    label: "PAGOS",
    title: "MAS METODOS DE COMPRA",
    sub: "Proximamente mas formas de comprar!",
    cta: "ML",
    dark: false,
  }
]

/* ─── Líneas de producto ─────────────────────────────────────── */
const PRODUCT_LINES = [
  { id: 1, category: "Figuras premium",  lines: ["S.H.Figuarts", "Figma", "Tenitol"],      icon: "pi pi-star"  },
  { id: 2, category: "Coleccionables",   lines: ["Nendoroid", "POP UP Parade"],             icon: "pi pi-heart" },
  { id: 3, category: "Model kits",       lines: ["Gundam", "High Grade", "Master Grade"],   icon: "pi pi-cog"   },
];

const COLLAGE_ITEMS = [
  { id: 1, src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1/ShinobuSHFiguarts/oxvypa0ghgksk2qudctw?_a=BAMAPqZW0",        label: "S.H.Figuarts",    big: true, ctaPath: "/shop?name=S.H.FIguarts" },
  { id: 2, src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1/SylvanianCupboardToaster/dllu78tvppl6jxzrxqfr?_a=BAMAPqZW0", label: "Sylvanian Families", ctaPath: "/shop?name=Sylvanian Families" },
  { id: 3, src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1/hgbarbatoslupus/z4tddfewyvdxqpclbjqx?_a=BAMAPqZW0",          label: "Bandai Hobby",    ctaPath: "/shop?brand=Bandai%20Hobby" },
  { id: 4, src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1/NendoroidZenitsu/hjm8aurjdkqqdaeazw7p?_a=BAMAPqZW0",         label: "Nendoroid",       ctaPath: "/shop?name=Nendoroid" },
  { id: 5, src: "https://res.cloudinary.com/dt532gwwq/image/upload/v1/Figma2B/qxjqn2fhjvycbxizcymc?_a=BAMAPqZW0",                  label: "Figma",           ctaPath: "/shop?name=Figma" },
];

/* ─── Banner template ────────────────────────────────────────── */
const BannerTemplate = ({ banner, navigate }) => (
  <div className={`home-banner__slide ${banner.dark ? "home-banner__slide--dark" : ""}`}>
    <img src={banner.src} alt={banner.alt} className="home-banner__img" loading="eager" />
    <div className="home-banner__overlay" />
    <div className="home-banner__content">
      {banner.label && <span className="home-banner__label">{banner.label}</span>}
      <h2 className="home-banner__title">{banner.title}</h2>
      <p className="home-banner__sub">{banner.sub}</p>
      {banner.cta && (
        <button className="home-banner__cta" onClick={() => navigate(banner.ctaPath)}>
          {banner.cta}<i className="pi pi-arrow-right" />
        </button>
      )}
    </div>
  </div>
);

/* ─── Componente ─────────────────────────────────────────────── */
const Home = () => {

  const [topProducts, setTopProducts] = useState([]);
  const navigate = useNavigate();
    const isMobile = useIsMobile();
  const banners = isMobile ? MOBILEBANNERS : WEBBANNERS;

  useEffect(() => {
    const init = async () => {
      try {
        await initStoreServices();
        await initCloudServices();
      } catch (e) {
        console.error("Error cargando servicios iniciales:", e);
      }
    };
    init();
  }, []);

  // Load top products
  useEffect(() => {
    const loadTopProducts = async () => {
      const data = await getLatestTopProducts();
      const fetchedProducts = data.result || data;
      setTopProducts(await mapApiProductsToTopProducts(fetchedProducts));
    };

    loadTopProducts();
  }, []);

  // Map API products to top products
const mapApiProductsToTopProducts = async (products = []) => {
  return Promise.all(products.map(async (product, index) => {
    const src = await getFirstImageFromCloudinary(product.folder_name, product.image_id);
    return {
      id: product.id ?? product.product_id ?? index + 1,
      rank: index + 1,
      src,
      name: product.name || product.title || "Producto",
      line: product.serie || product.brand || product.category || "Sin línea",
      path: "/product/" + product.id,
    };
  }));
};

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = () => setIsMobile(mq.matches);

    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
}

  return (
    <main className="home">

      {/* ── Carrusel de banners ───────────────────────────────── */}
      <section className="home-banner">
        <Carousel
          value={banners}
          itemTemplate={(banner) => <BannerTemplate banner={banner} navigate={navigate} />}
          numVisible={1}
          numScroll={1}
          autoplayInterval={4000}
          circular
          showThumbnails={false}
          showIndicators
          showNavigators
          className="home-banner__carousel"
        />
      </section>

      {/* ── Hero compacto (sin imagen de marca) ───────────────── */}
      <section className="home-hero">
        <div className="home-hero__content">
          <div className="home-hero__tag">Angelvarius Shop</div>
          <h1 className="home-hero__title">
            Coleccionables <em>importados</em> de Japón
          </h1>
          
          <Button
            label="Ver productos"
            icon="pi pi-arrow-right"
            iconPos="right"
            className="home-hero__cta"
            onClick={() => navigate("/shop")}
          />

          <p className="home-hero__sub">
            100% originales, nuevos y sellados. Las marcas más reconocidas
            del mercado japonés, en un solo lugar.
          </p>
        </div>
      </section>

      {/* ── Top 10 productos ──────────────────────────────────── */}
      <section className="home-top">
        <div className="home-top__header">
          <div className="home-top__header-left">
            <span className="home-top__tag">Recién llegados</span>
            <h2 className="home-top__title">Novedades</h2>
          </div>
          <button className="home-top__ver-mas" onClick={() => navigate("/shop")}>
            Ver todos <i className="pi pi-arrow-right" />
          </button>
        </div>

        <div className="home-top__track-wrap">
          <div className="home-top__track">
            {topProducts.map((item) => (
              <div
                key={item.product_id}
                className="home-top__card"
                onClick={() => navigate(item.path)}
              >
                <span className="home-top__rank">
                  #{item.rank}
                </span>
                <div className="home-top__img-wrap">
                  <img src={item.src} alt={item.name} loading="lazy" />
                </div>
                <div className="home-top__info">
                  <span className="home-top__line">{item.line}</span>
                  <p className="home-top__name">{item.name}</p>
                  <p className="home-top__price">{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Perks bar ─────────────────────────────────────────── */}
      <div className="home-perks">
        <div className="home-perks__item">
          <i className="pi pi-verified home-perks__icon" />
          <div>
            <p className="home-perks__label">100% originales</p>
            <p className="home-perks__desc">Importados directamente desde Japón, nuevos y sellados.</p>
          </div>
        </div>
        <div className="home-perks__item">
          <i className="pi pi-sync home-perks__icon" />
          <div>
            <p className="home-perks__label">Stock actualizado diario</p>
            <p className="home-perks__desc">Revisamos y subimos nuevas piezas todos los días.</p>
          </div>
        </div>
        <div className="home-perks__item">
          <i className="pi pi-comments home-perks__icon" />
          <div>
            <p className="home-perks__label">Cotizaciones</p>
            <p className="home-perks__desc">¿No encuentras lo que buscas? Te lo conseguimos.</p>
          </div>
        </div>
      </div>

      {/* ── Líneas de producto ─────────────────────────────────── */}
      <section className="home-section">
        <div className="home-section__header">
          <span className="home-section__tag">Catálogo</span>
          <h2 className="home-section__title">Líneas con las que trabajamos</h2>
          <p className="home-section__desc">
            En <strong>Angelvarius</strong> encontrarás figuras de tus personajes favoritos
            de las marcas más reconocidas del mercado japonés.
          </p>
        </div>
        <div className="home-lines">
          {PRODUCT_LINES.map((item) => (
            <div
              key={item.id}
              className="home-lines__card"
              onClick={() => navigate(`/shop?category=${item.id}`)}
              style={{ cursor: "pointer" }}
            >
              <div className="home-lines__card-top">
                <i className={`${item.icon} home-lines__card-icon`} />
                <h3 className="home-lines__card-title">{item.category}</h3>
              </div>
              <ul className="home-lines__card-list">
                {item.lines.map((line) => (
                  <li key={line} className="home-lines__card-item">
                    <span className="home-lines__card-dot" />
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* ── Collage ───────────────────────────────────────────── */}
      <section className="home-collage-section">
        <div className="home-section__header">
          <span className="home-section__tag">Galería</span>
          <h2 className="home-section__title">Algunos de nuestros productos</h2>
          <p className="home-section__desc">
            Piezas seleccionadas de nuestro catálogo. Visita la tienda para ver el inventario completo.
          </p>
        </div>
        <div className="home-collage">
          {COLLAGE_ITEMS.map((item) => (
            <div key={item.id} onClick={() => navigate(item.ctaPath)} className={`collage-cell ${item.big ? "cell-big" : ""}`}>
              {item.src ? (
                <>
                  <img src={item.src} alt={item.label} loading="lazy" />
                  <span className="collage-cell__label">{item.label}</span>
                </>
              ) : (
                <div className="collage-cell__placeholder">
                  <i className="pi pi-image" />
                  <span>{item.label}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA final ─────────────────────────────────────────── */}
      <section className="home-cta">
        <h2 className="home-cta__title">¿Listo para encontrar tu figura?</h2>
        <p className="home-cta__desc">
          Stock limitado — se actualiza a diario. Contáctanos en redes sociales
          para cotizaciones o cualquier consulta.
        </p>
        <Button
          label="Explorar el catálogo"
          icon="pi pi-arrow-right"
          iconPos="right"
          className="home-hero__cta align-self-center"
          onClick={() => navigate("/shop")}
        />
      </section>

      {/* ── Aviso de desarrollo ───────────────────────────────── */}
      <div className="home-notice">
        <i className="pi pi-info-circle home-notice__icon" />
        <div>
          <p className="home-notice__title">Sitio en desarrollo</p>
          <p className="home-notice__text">
            Por el momento no se realizan compras en línea. El objetivo es presentar
            productos y controlar el stock. El servidor puede tardar hasta un minuto
            en responder en la primera carga.
          </p>
        </div>
      </div>

    </main>
  );
};

export default Home;
